import useModels from '../../../Hooks/useModels';
import ToggleSwitch from '../../Utility/ToggleSwitch';
import { ModelsTabName } from '../../../Types/Enums';
import EmbeddingModels from './components/EmbeddingModels';
import ChatModels from './components/ChatModels';
import AdminContainer from '../../Utility/AdminContainer';
import useGlobals from '../../../Hooks/useGlobals';
function Models() {
    const { settings } = useGlobals();
    const { userSettings, i18n, currentTab, setCurrentTab } = useModels();

    return userSettings.isSuperAdmin || settings.demo ? (
        <div className={`admin-container flex relative flex-col`}>
            <AdminContainer>
                <div className="mb-5 w-full">
                    <ToggleSwitch
                        options={[
                            {
                                label: i18n.translate({ id: 'chatModels', sourceName: 'Models' }),
                                function: () => setCurrentTab(ModelsTabName.chatModels),
                                active: currentTab === ModelsTabName.chatModels,
                            },
                            {
                                label: i18n.translate({ id: 'embeddingModels', sourceName: 'Models' }),
                                function: () => setCurrentTab(ModelsTabName.embeddingModels),
                                active: currentTab === ModelsTabName.embeddingModels,
                            },
                        ]}
                    />
                </div>
                <div className="box">
                    {currentTab === ModelsTabName.chatModels && <ChatModels />}
                    {currentTab === ModelsTabName.embeddingModels && <EmbeddingModels />}
                </div>
            </AdminContainer>
        </div>
    ) : (
        <></>
    );
}

export default Models;
